<template>
  <mdb-modal :show="show" @close="show = false" info>
    <mdb-modal-header>
      <mdb-modal-title>{{currentNotification ? currentNotification.notification.title : "Error"}}</mdb-modal-title>
    </mdb-modal-header>
    <mdb-modal-body>
        {{currentNotification ? currentNotification.notification.body : "Une erreur est survenue avec les notifications..."}}
    </mdb-modal-body>
    <mdb-modal-footer center>
      <mdb-btn outline="orange darken-1" rounded @click="show = false">Plus tard</mdb-btn>
      <mdb-btn id="acceptAll" class="orange darken-1" rounded @click="goToLink">Voir</mdb-btn>
    </mdb-modal-footer>
  </mdb-modal>
</template>
<script>
import {
  mdbRow,
  mdbIcon,
  mdbModal,
  mdbModalHeader,
  mdbModalTitle,
  mdbModalBody,
  mdbModalFooter
} from "mdbvue";
import {mapActions, mapState } from "vuex";
export default {
  name: "ModalEventsPage",
  components: {
    mdbIcon,
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter
  },
  computed: {
      ...mapState("notifications", ["notifications"]),
        currentNotification: function(){
            if(this.notifications.length == 0) return null;
            return this.notifications[0];
        }
  },
  data() {
    return {
      show: false
    };
  },
  watch: {
    notifications: {
      immediate: true,
      handler: function(val) {
          this.show = val && val.length > 0;
      }
    }
  },
  methods: {
      ...mapActions("notifications",["removeNotification"]),
    goToLink: function(){
        let url = this.currentNotification.fcmOptions.link.replace("https://please-be-true.web.app/","");
        console.log(url);
        this.$router.push({ path: url});
        this.show = false;
        this.removeNotification(this.currentNotification);
    }
  }
};
</script>